import { render } from "./page-news.vue?vue&type=template&id=0982884a&scoped=true"
import script from "./page-news.vue?vue&type=script&lang=js"
export * from "./page-news.vue?vue&type=script&lang=js"

import "./page-news.vue?vue&type=style&index=0&id=0982884a&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0982884a"]])

export default __exports__